import React from 'react';
import classNames from 'classnames';
import verticalNavigationStyles from 'components/shared/VerticalNavigation/VerticalNavigation.module.scss';
import styles from './SkeletonVerticalNavigation.module.scss';

export const SkeletonVerticalNavigation: React.FC = () => {
  return (
    <div
      className={classNames(
        verticalNavigationStyles.appsColumn,
        verticalNavigationStyles.container
      )}
    >
      <div className={classNames(verticalNavigationStyles.innerWrap)}>
        <div className={styles.members}>
          <div className={styles.member}>
            <div className={styles.memberAvatar}></div>
            <div className={styles.memberName}></div>
          </div>
          <div className={styles.member}>
            <div className={styles.memberIntegration}></div>
            <div className={styles.memberName}></div>
          </div>
          <div className={styles.member}>
            <div className={styles.memberIntegration}></div>
            <div className={styles.memberName}></div>
          </div>
          <div className={styles.member}>
            <div className={styles.memberIntegration}></div>
            <div className={styles.memberName}></div>
          </div>
        </div>
      </div>
    </div>
  );
};
